import { isBrowser } from '@/utils/environment';
import { Router } from 'next/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export function useNProgress() {
  Router.events.on('routeChangeStart', () => NProgress.start());
  Router.events.on('routeChangeComplete', () => {
    NProgress.done();

    if (isBrowser()) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  });
  Router.events.on('routeChangeError', () => NProgress.done());
}
